import {
  COMPANY_UTC_OFFSET_MINUTES,
  toCompanyMoment,
} from "@/util/companyTime";

// Company (books) time: Damascus, a fixed UTC+3, no DST since 2022.
export var FINANCE_UTC_OFFSET_MINUTES = COMPANY_UTC_OFFSET_MINUTES;

// Accountant doc 2026-10-03 item 1.8: the finance API now sends timestamps as
// local wall-clock strings ("2026-10-03 14:05:00"), which are printed as they
// are. A value that still carries a zone ("...T11:05:00.000000Z" or
// "+00:00", e.g. from an older endpoint) is converted to company time first,
// so it can never show three hours early again, whatever the viewer's PC
// timezone is. Final-version doc 2026-10-05: the conversion now lives in
// util/companyTime.js, shared with every non-finance screen, so the finance
// pages and the wallet / transfer pages always agree.
var ZONED = /T.*([zZ]|[+-]\d{2}:?\d{2})$/;

export function formatFinanceDate(value, withSeconds) {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  var format = withSeconds ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD HH:mm";

  if (typeof value === "number") {
    var instant = toCompanyMoment(value);
    return instant ? instant.format(format) : "-";
  }

  var text = String(value).trim();
  var length = withSeconds ? 19 : 16;

  if (ZONED.test(text)) {
    var parsed = toCompanyMoment(text);
    if (parsed) {
      return parsed.format(format);
    }
  }

  return text.replace("T", " ").substring(0, length);
}

export default {
  methods: {
    formatFinanceDate: formatFinanceDate,
  },
};
